export class BmsTrustee {
  id : string;
  name :string;
  billingEnabled : boolean;
  enabled : boolean = true;
}
